import React from 'react';
import { Link } from 'react-router-dom';
import './PromotionBanner.css';
import odaTermostat from '../../images/oda_termostat.png';

const PromotionBanner = () => {
  return (
    <section className="promotion-banner">
      <div className="promotion-container card">
        <div className="promotion-image-container">
          <img
            src={odaTermostat}
            alt="Oda termostatı montajı - enerji tasarrufu"
            className="promotion-image"
            loading="lazy"
          />
        </div>
        <div className="promotion-content">
          <h2 className="promotion-title">Oda Termostatı ile Konfor ve Enerji Tasarrufu</h2>
          <p className="promotion-text">
            Evinizin sıcaklığını kontrol altına alın! Akıllı oda termostatı ile kombiniz
            sadece ihtiyaç duyulduğunda çalışır. Enerji verimliliği artar, faturalar düşer.
            Üç Kardeşler Servis garantisiyle aynı gün montaj imkanı.
          </p>
          <div className="promotion-buttons-wrapper">
            <Link to="/iletisim" className="btn btn-call">
              Hemen Randevu Al
            </Link>
            <Link to="/servislerimiz/oda-termostati" className="btn btn-outline">
              Daha Fazla Bilgi
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionBanner;
